import logUtil from 'utils/log'
import getCurrentIdProductSelect from 'modules/product/redux/selectors/get-current-id'
import isSampleVariantSelect from 'modules/product/redux/selectors/is-sample'
import getSelectedColorVariantId from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import updateQuickShopHistoryProductsAction from 'modules/product/redux/actions/update-quick-shop-history'
import getQuickShopHistoryProductsSelect from 'modules/product/redux/selectors/get-quick-shop-history'
import getCurrentIdVariantSelect from 'modules/variant/redux/selectors/get-current-id'

export default function addQuickShopHistoryItemProductAction () {
  return (dispatch, getState) => {
    const quickShopHistory = getQuickShopHistoryProductsSelect(getState()) || []
    const productId = getCurrentIdProductSelect(getState())
    const variantId = getCurrentIdVariantSelect(getState())
    const selectedVariantId = getSelectedColorVariantId(getState())
    const isSample = isSampleVariantSelect(getState())

    const logPrefix = `productId=${productId} variantId=${variantId} selectedVariantId=${selectedVariantId}`
    const debugProps = {
      quickShopHistory,
      isSample
    }

    logUtil('addQuickShopHistoryItemProductAction').debug(`${logPrefix} debugProps=`, debugProps)
    const isAlreadyInHistory = quickShopHistory?.some((product) => {
      return (
        product.productId === productId &&
        product.variantId === variantId &&
        product.selectedVariantId === selectedVariantId
      )
    })
    if (isAlreadyInHistory) {
      logUtil('addQuickShopHistoryItemProductAction').debug(`${logPrefix} [noop] already in history`)
      return
    }

    const lastProduct = quickShopHistory?.[quickShopHistory.length - 1]
    if (lastProduct?.productId === productId) {
      const newHistoryItem = {
        ...lastProduct,
        isSample,
        variantId
      }
      const newHistory = [
        ...quickShopHistory.slice(0, quickShopHistory.length - 1),
        newHistoryItem
      ]
      logUtil('addQuickShopHistoryItemProductAction').debug(`${logPrefix} same product id, updating variant id newHistory=`, newHistory)
      dispatch(
        updateQuickShopHistoryProductsAction(newHistory)
      )
      return
    }

    /**
     * @type {QuickShopHistoryItem}
     */
    const newQuickShopHistoryItem = {
      productId,
      variantId,
      isSample
    }
    if (selectedVariantId) {
      newQuickShopHistoryItem.selectedVariantId = selectedVariantId
    }

    const newQuickShopHistory = [
      ...quickShopHistory,
      newQuickShopHistoryItem
    ]

    dispatch(
      updateQuickShopHistoryProductsAction(newQuickShopHistory)
    )

    logUtil('addQuickShopHistoryItemProductAction').debug(`${logPrefix} [done] newQuickShopHistory=`, newQuickShopHistory)
  }
}
